// this file overrides the default lodash templating syntax

import templateSettings from 'lodash.templatesettings';

export default () =>
  templateSettings.interpolate = /\%\{(.+?)\}/g;
